export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5019.f12a0c51.jpg";